<template>
  <div>
    <v-container class="">
      <v-row no-gutters class="pagination-table-header">
        <v-col col="12">
          <v-overlay :absolute="true" :value="isComponentLoading">
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3"
          >
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b
              >&nbsp;&nbsp;{{
                  lang($store, 'sap/listings.cleaners.not_found')
                }}&nbsp;&nbsp;</b
              >
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-row class="mt-5">
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="key"
                cols="12"
                md="4"
                lg="4"
                xl="3"
                class="mb-4"
              >
                <v-card class="pa-1" tile flat elevation="2">
                  <v-row
                  >
                    <v-col>
                      <div
                        :class="
                          `${cardColor(item)} ${cardTextColor(item)}--text`
                        "
                        class="pa-1"
                      >
                        <div class="d-flex justify-space-between">
                          <div>
                            <div>{{ item.name }}</div>
                            <phone-chip
                              :small="true"
                              :color="cardTextColor(item)"
                              :text-color="cardTextColor(item)"
                              :phone="item.phone"
                            />
                          </div>
                          <div class="caption">{{$t('enums.region.'+item.region)}}</div>
                        </div>
                        <div
                          class="d-block d-sm-inline-block body-2 font-weight-light"
                        >
                          {{ $t('enums.roles.'+item.role)}}
                          <span v-if="item.rank">
                            ({{ $t('enums.ranks.'+item.rank)}})
                          </span>
                          <span v-if="item.carier_start_at">
                            [{{ item.carier_start_at.format(DATE_VIEW) }}]
                          </span>
                        </div>
                      </div>
                    </v-col>
                  </v-row
                  >
                  <hr/>
                  <ScheduleTable
                    :value="item.schedule"
                    :uuid="item.uuid"
                    @input="onChange"
                  />
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
/* components */
import PhoneChip from '@/components/minialerts/PhoneChip.vue';
import ScheduleTable from '@/components/ScheduleTable.vue';
// import CleanerScheduleTable from '@/components/listings/CleanerScheduleTable.vue';
// eslint-disable-next-line import/no-unresolved

// import StarRating from 'vue-star-rating';
/* constants */
import { MANAGERS } from '@/constants/roles';
import { DATE_VIEW } from '@/constants/dates';
/* utils */
import {
  roles as rolesColors,
  rolesText as rolesTextColors,
} from '../../utils/listingColors';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';
import cardColorsMixin from '../../mixins/cardColorsMixin';

export default {
  name: 'PaginatedCleanerSchedules',
  mixins: [isComponentLoading, cardColorsMixin],
  components: {
    PhoneChip,
    ScheduleTable,
  },
  data() {
    return {
      DATE_VIEW,
      MANAGERS,
      rolesColors,
      rolesTextColors,
      L: _,
      avatarDialog: false,
      avatarDialogSrc: '',
    };
  },
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onChange(val) {
      this.$emit('input-schedule', { ...val });
    },
  },
};
</script>

<style lang="sass" scoped>
table
  border-collapse: collapse

  tr
    td, th
      border: 1px solid lightgrey

.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer

.v-card__actions .v-btn
  min-width: auto
</style>
